import React from 'react';
import { Grid, Link } from '@mui/material';
import { useTranslation } from 'react-i18next';

const AuthFooter = () => {
  const { t } = useTranslation();

  const LINKS = {
    website: 'https://www.businesskitz.com',
    contact: 'https://www.businesskitz.com/contact',
    privacyProlicy: 'https://www.businesskitz.com/privacy-policy',
    termsAndConditions: 'https://www.businesskitz.com/terms-and-conditions',
  };
  return (
    <Grid
      container
      className='demo-auth-footer position-relative bottom-0 start-0 w-100 py-2 text-center mt-4 justify-content-center align-items-center d-flex flex-column'
    >
      <Grid container justifyContent='center' spacing={4}>
        <Grid>
          <Link
            href={LINKS.contact}
            target='_blank'
            rel='noreferrer noopener'
            className='text-inherit text-decoration-none'
          >
            {t('footerLinks.support')}
          </Link>
        </Grid>
        <Grid>
          <Link
            href={LINKS.privacyProlicy}
            target='_blank'
            rel='noreferrer noopener'
            className='text-inherit text-decoration-none'
          >
            {t('footerLinks.privacyPolicy')}
          </Link>
        </Grid>
        <Grid>
          <Link
            href={LINKS.termsAndConditions}
            target='_blank'
            rel='noreferrer noopener'
            className='text-inherit text-decoration-none'
          >
            {t('footerLinks.termsAndConditions')}
          </Link>
        </Grid>
      </Grid>
      <Grid sx={{ mt: 2 }}>
        <Link href={LINKS.website} target='_blank' rel='noreferrer noopener'>
          {t('footerLinks.businessKitz')}
        </Link>
      </Grid>
    </Grid>
  );
};

export default AuthFooter;
